<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> IMPORTAR TABELA DE PREÇOS </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="green darken-3" class="mr-7" @click="updatePrices()">
          <v-icon left>mdi-cash</v-icon> Atualizar Preços
        </v-btn>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="provider"
                :items="providers"
                label="Fornecedor"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <!-- <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="collection"
                :items="collections"
                item-text="name"
                item-value="id"
                label="Coleção"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col> -->
            <v-col cols="12" xs="12" md="3">
              <v-file-input
                label="Tabela de Preços"
                outlined
                dense
                required
                multiple
                @change="onFilePicked"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                prepend-icon="mdi-file-excel"
              ></v-file-input>
            </v-col>
            <v-col>
              <v-btn color="blue darken-3" @click="handleImport()" dark
                ><v-icon left>mdi-upload</v-icon> Importar</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table fixed-header height="450px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="100">Referência</th>
                      <th class="text-left" width="250">Produto</th>
                      <th class="text-right" width="150">R$ Rede</th>
                      <th class="text-right" width="150">R$ Multi.</th>
                      <th class="text-right" width="150">R$ Novo Rede</th>
                      <th class="text-right" width="150">R$ Novo Multi.</th>
                      <th class="text-right" width="160">% Reajuste Rede</th>
                      <th class="text-right" width="160">% Reajuste Multi.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in productsSelected" :key="item.id">
                      <td class="font-weight-bold">{{ item.referencia }}</td>
                      <td v-if="item.produto.name">
                        {{ item.produto.name }}
                      </td>
                      <td v-else class="red--text font-weight-bold">
                        Produto não encontrado
                      </td>
                      <td class="text-right">{{ item.produto.price_cif }}</td>
                      <td class="text-right">{{ item.produto.price_mult }}</td>
                      <td class="text-right">
                        <v-text-field
                          hide-details
                          outlined
                          dense
                          class="text-right"
                          @input="handleChangeNewPriceCif(item)"
                          @blur="handleBlurNewPriceCif(item)"
                          v-model.number="item.preco_rede"
                          :disabled="!hasProduct(item)"
                          readonly
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          hide-details
                          outlined
                          dense
                          class="text-right"
                          @input="handleChangeNewPriceMult(item)"
                          @blur="handleBlurNewPriceMult(item)"
                          v-model.number="item.preco_multi"
                          :disabled="!hasProduct(item)"
                          readonly
                        ></v-text-field>
                      </td>
                      <td class="text-right">{{ item.percent_cif }}%</td>
                      <td class="text-right">{{ item.percent_mult }}%</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    provider: "",
    providers: [],
    productsSelected: [],
    file: null,
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getProviders();
    },
    async getProviders() {
      // this.showLoading();
      this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.providers = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        console.log(this.providers);
      } catch (error) {
        this.providers = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "UpdatePrice" });
    },
    updatePrices() {},
    onFilePicked(file) {
      this.file = file[0];
    },
    handleChangeNewPriceCif() {},
    handleBlurNewPriceCif() {},
    handleChangeNewPriceMult() {},
    handleBlurNewPriceMult() {},
    async handleImport() {
      let form = new FormData();
      form.append("file", this.file);

      this.loading = true;
      this.productsSelected = [];
      try {
        let res = await fetch(`${URL}upload-file-price`, {
          method: "POST",
          body: form,
        });
        if (res) {
          console.log(res);
          let data = await res.json();
          this.productsSelected = data.map((item) => {
            return {
              ...item,
              percent_cif: this.hasProduct(item)
                ? this.calculatePercent(
                    item.produto.price_cif,
                    item.preco_rede.replace(/\./g, "").replace(",", ".")
                  )
                : 0,
              percent_mult: this.hasProduct(item)
                ? this.calculatePercent(
                    item.produto.price_mult,
                    item.preco_multi.replace(/\./g, "").replace(",", ".")
                  )
                : 0,
            };
          });
          console.log(this.productsSelected);
          // this.productsSelected = await res.json();
          // this.showAlert({
          //   message: "Tipo de Fornecedor salvo com sucesso",
          //   type: "success",
          // });
          // this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }

      console.log(this.file);
    },
    calculatePercent(oldPrice, newPrice) {
      console.log({ oldPrice });
      console.log({ newPrice });
      return ((parseInt(newPrice) / parseInt(oldPrice) - 1) * 100).toFixed(2);
      // return percent;
    },
    hasProduct(item) {
      console.log(typeof item.produto.name);
      return typeof item.produto.name !== "undefined";
    },
  },
};
</script>
<style scoped>
.text-red {
  color: "red";
}
.product-not-found {
  background-color: "red";
}
</style>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
